import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Scene } from '../models/Scene';
import { NgForm } from '@angular/forms';
import { API_SETTINGS } from './API_SETTINGS';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const httpOptionsText = {
  headers: new HttpHeaders({'Content-Type': 'text/plain'})
};

const apiUrl = API_SETTINGS.API_URL + 'Scene';

@Injectable({
  providedIn: 'root'
})
export class ApiSceneService {

  constructor(private http: HttpClient) { }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getScenes(): Observable<Scene[]> {
    const url = apiUrl+'/GetScenes';
    return this.http.get<Scene[]>(url).pipe();
  }
  
  getScene(id: number): Observable<Scene> {
    const url = `${apiUrl}/GetScene/${id}`;
    return this.http.get<Scene>(url).pipe();
  }

  getScenesWithProjectId(id: number): Observable<Scene[]>{
    const url = `${apiUrl + '/GetActiveScenesWithProjectId'}/${id}`;
    return this.http.get<Scene[]>(url).pipe();
  }

  getScenesWithBackgroundSrc(sceneBackgroundSrc: string): Observable<Scene[]>{
    const url = `${apiUrl + '/GetActiveScenesWithBackgroundSrc'}`;
    return this.http.post<Scene[]>(url, `"${sceneBackgroundSrc}"`, httpOptions).pipe();
  }

  addScene(scene: Scene): Observable<Scene>{ 
    const url = apiUrl +'/PostScene'; 
    return this.http.post<Scene>(url, scene, httpOptions).pipe();
  }
  
  updateScene (id: number, Scene: any): Observable<Scene>{
    const url = `${apiUrl}/PutScene/${id}`;
    return this.http.put(url, Scene, httpOptions).pipe(
      tap((SceneRes: Scene) => true ), //()),
      catchError(this.handleError<Scene>('updateScene'))
    )
  }
  
  setSceneUploadStatusComplete (id: number, Scene: any): Observable<Scene>{
    const url = `${apiUrl}/PutSceneUploadStatusComplete/${id}`;
    return this.http.put(url, Scene, httpOptions).pipe(
      tap((SceneRes: Scene) => true ), //console.log()),
      catchError(this.handleError<Scene>('Set Scene Upload Status Complete'))
    )
  }
 
  deleteScene(id: number): Observable<Scene> {
    const url = `${apiUrl}/DeleteScene/${id}`;
    return this.http.delete<Scene>(url, httpOptions).pipe();
  }
  
}
